import { clearJwtStorage } from './jwt-storage';
const AUTH_STORAGE_KEY = 'callCenterAuth';
export function getStoredAuth() {
    if (typeof window === 'undefined' || !window.localStorage) {
        return null;
    }
    try {
        const raw = window.localStorage.getItem(AUTH_STORAGE_KEY);
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        if (!parsed?.username || !Array.isArray(parsed.roles) || !Array.isArray(parsed.permissions)) {
            return null;
        }
        return {
            ...parsed,
            roles: parsed.roles.filter((r) => typeof r === 'string' && r.trim().length > 0),
            permissions: parsed.permissions.filter((p) => typeof p === 'string' && p.trim().length > 0),
        };
    }
    catch {
        return null;
    }
}
export function setStoredAuth(session) {
    if (typeof window === 'undefined' || !window.localStorage)
        return;
    window.localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(session));
}
/** Remove cached account snapshot only — keeps JWT so IAM logout can run. */
export function clearStoredSessionSnapshot() {
    if (typeof window === 'undefined' || !window.localStorage)
        return;
    window.localStorage.removeItem(AUTH_STORAGE_KEY);
}
export function clearStoredAuth() {
    if (typeof window === 'undefined' || !window.localStorage)
        return;
    clearStoredSessionSnapshot();
    clearJwtStorage();
}
/** Optional dev-only demo bypass (requires explicit env). Kept narrow for local mocks. */
export const DEMO_LOGIN_ENABLED = typeof process.env.ENABLE_DEMO_LOGIN === 'string' &&
    /^(1|true|yes)$/i.test(process.env.ENABLE_DEMO_LOGIN.trim());
export const DEMO_USERNAME = 'admin';
export const DEMO_PASSWORD = 'admin';
/** Session used only when ENABLE_DEMO_LOGIN is set — not for production ShahyPay auth. */
export function createDemoAdminSession() {
    return {
        username: DEMO_USERNAME,
        roles: ['ROLE_ADMIN'],
        permissions: ['*'],
    };
}
